//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  name: "PublicLayout",
  data() {
    return {
      "title": ""
    }

  },
  created() {
  },
  mounted() {
    console.log("titel: "+window.$config.title);
    this.title = window.$config.title;
  },
  computed: {
    appTypeIsSaf() {
      return window.$config.APP_TYPE == "saf";
    }
  }
}
